<template>
  <router-view class="h-100"/>
</template>

<script>
import {mapActions,mapState} from 'vuex';
import {auth} from '@/firebase.js';
export default {
	methods:{
		...mapActions(['loginUsuario','logoutUsuario'])
	},
	computed:{
		...mapState(['menu'])
	},
  	created(){
	  	var that = this;
	  	auth.onAuthStateChanged(function(user) {
	      if (user) {
	        that.loginUsuario(user);
	        if (that.$route.name=='Login') {
	        	that.$router.push({name:'Dashboard'});
	        }
	      } else {
	        that.logoutUsuario();
	        if (that.$route.name!='Login') {
	          that.$router.push({name:'Login'});
	        }
	        that.menu.ready=true;
	      }
	    });
  	}
};
</script>

<style>
html {
  height: 100%;
}
body {
  min-height: 100%;
}
.li_inactiva{
	color:#1f2d41 !important;
}
.li_active{
	color:#401b4c !important;
}
.bg-innovation{
	background-color: #401b4c !important;
}
.text-innovation{
	color: #401b4c !important;
}
.btn-innovation{
	background-color: #401b4c !important;
	color:white !important;
}

</style>



// WEBPACK FOOTER //
// src/App.vue